import { useInView } from "framer-motion";
import React, { useState, useEffect, useRef } from "react";

const DELAY = 0;
const SPEED = 50;
const INITIAL_INDEX = 0;

interface TypingAnimationProps {
  children: React.ReactNode;
}

export function TypingAnimation({ children }: TypingAnimationProps) {
  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(INITIAL_INDEX);

  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref);

  const text = typeof children === "string" ? children : String(children);

  useEffect(() => {
    if (!isInView) {
      setDisplayedText("");
      setCurrentIndex(0);
      return;
    }

    if (currentIndex >= text.length) {
      return;
    }

    const timer = setTimeout(
      () => {
        setDisplayedText(text.slice(0, currentIndex + 1));
        setCurrentIndex(currentIndex + 1);
      },
      currentIndex === 0 ? DELAY : SPEED,
    );

    return () => clearTimeout(timer);
  }, [currentIndex, text, isInView]);

  useEffect(() => {
    setDisplayedText("");
    setCurrentIndex(0);
  }, [children]);

  return <span ref={ref}>{displayedText}</span>;
}
